import HomePageAdmin from './HomePageAdmin';

export default HomePageAdmin;
